import api from './api';
import {
  BulkQuestionStatusRequest,
  QuestionDetail,
  QuestionListQueryParams,
  QuestionListResponse,
  QuestionPayload,
  QuestionReferenceData,
} from '../types';

export const fetchQuestions = async (
  params: QuestionListQueryParams,
  signal?: AbortSignal
): Promise<QuestionListResponse> => {
  const response = await api.get('/questions', {
    params,
    signal,
  });

  return response.data.data;
};

export const fetchQuestionById = async (
  id: string,
  signal?: AbortSignal
): Promise<QuestionDetail> => {
  const response = await api.get(`/questions/${id}`, {
    signal,
  });

  return response.data.data;
};

export const fetchQuestionReferenceData = async (
  signal?: AbortSignal
): Promise<QuestionReferenceData> => {
  const response = await api.get('/questions/reference', {
    signal,
  });

  return response.data.data;
};

export const fetchQuestionGroupTypes = async (
  signal?: AbortSignal
): Promise<string[]> => {
  const response = await api.get('/questions/group-types', {
    signal,
  });

  return response.data.data.groupTypes;
};

export const createQuestion = async (payload: QuestionPayload): Promise<QuestionDetail> => {
  const response = await api.post('/questions', payload);
  return response.data.data;
};

export const updateQuestion = async (
  id: string,
  payload: QuestionPayload
): Promise<QuestionDetail> => {
  const response = await api.put(`/questions/${id}`, payload);
  return response.data.data;
};

export const deleteQuestion = async (id: string): Promise<void> => {
  await api.delete(`/questions/${id}`);
};

export const bulkUpdateQuestionStatus = async (
  payload: BulkQuestionStatusRequest
): Promise<{ updatedCount: number }> => {
  const response = await api.post(
    '/questions/bulk/status',
    payload
  );

  return response.data.data;
};
